import moment from 'moment';

export const DATE_FORMAT = 'YYYY-MM-DD';

const ALL_WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];

// selectable range and weekdays of a date field, shared by the calendar and the form default
export function getCalendarDateMeta(date) {
    const today = moment().startOf('day');

    // calendar start date
    const startDate = date?.startDate ? moment(date.startDate).startOf('day') : today.clone();

    // calendar end date
    let endDate = date?.endDate ? moment(date.endDate).endOf('day') : moment().add(5, 'year').endOf('day');
    const limitedDay = date?.dayLimit ? moment().add(date.dayLimit, 'day').endOf('day') : null;

    if (limitedDay && limitedDay.isBefore(endDate)) {
        endDate = limitedDay;
    }

    const availableWeekdays = date?.weekday ? date.weekday.map(d => parseInt(d)) : ALL_WEEKDAYS;

    return { today, startDate, endDate, availableWeekdays };
}

// nearest date the user is allowed to pick, searching from today onwards
export function findNearestAvailableDate(date) {
    const { today, startDate, endDate, availableWeekdays } = getCalendarDateMeta(date);

    // never pre-select a past date, even when the start date is in the past
    const pivot = moment.max(today, startDate).clone();
    const rangeEnd = endDate.clone().startOf('day');

    while (pivot.isSameOrBefore(rangeEnd)) {
        if (availableWeekdays.includes(pivot.day())) {
            return pivot.format(DATE_FORMAT);
        }
        pivot.add(1, 'day');
    }

    return undefined;
}
